import { render, staticRenderFns } from "./PreviewIcon.vue?vue&type=template&id=2caa15f9"
import script from "./PreviewIcon.vue?vue&type=script&lang=js"
export * from "./PreviewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports